import React from 'react'
import ReactDOM from 'react-dom'
import i18next from 'i18next'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'

import App from './App'

import common_en from './translations/en/common.json'
import common_fr from './translations/fr/common.json'
import registerServiceWorker from './registerServiceWorker'
import './assets/css/index.scss'

if (sessionStorage.getItem('fonts-loaded')) {
  // fonts cached, add class to document
  document.documentElement.classList.remove('fonts-loading')
} else {
  // load script with font observing logic
  require('./utils/fonts-css-async')
}

i18next.init({
  interpolation: {
    escapeValue: false,
  },
  lng: window.location.host === 'domaine-madame-elisabeth.com' ? 'en' : 'fr',
  resources: {
    en: {
      common: common_en
    },
    fr: {
      common: common_fr
    },
  },
})

ReactDOM.render(
  <I18nextProvider i18n={i18next}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </I18nextProvider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js